import { render, staticRenderFns } from "./ReturnButton.vue?vue&type=template&id=3f615e32&"
import script from "./ReturnButton.vue?vue&type=script&lang=ts&"
export * from "./ReturnButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports